import { render, staticRenderFns } from "./CharactersBackgroundDetail.vue?vue&type=template&id=a8d69374&lang=pug&"
import script from "./CharactersBackgroundDetail.vue?vue&type=script&lang=ts&"
export * from "./CharactersBackgroundDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports